export const API_BASE_URL = 'https://cyber-ninja-bckend.onrender.com/api/';
export const API_IMAGE_BASE_URL = 'https://cyber-ninja-bckend.onrender.com';